import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

/**
 * This guard must be used on all root level routes. It ensures that the user is initialized (loaded from storage),
 * and validates that the user is signed in. If they are not signed in, it sends them to login.
 */
@Injectable({
  providedIn: 'root',
})
export class UserGuard {
  constructor(
    private auth: AuthService,
    private router: Router,
  ) {}

  async canActivate(): Promise<boolean> {
    // update the user's login status
    await this.auth.markUserLoginStatus();

    // if the user is logged in, they can go through to the route
    if (this.auth.isUserLoggedIn()) {
      return true;
    }
    // otherwise, send them to login
    this.router.navigate(['/login']);
    return false;
  }
}
